// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Chat Page Layout */
.modern-chat-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

[data-theme="dark"] .modern-chat-page {
  background: var(--bg-gradient);
  will-change: auto;
  transform: translateZ(0);
}

/* Floating Header */
.floating-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border-primary);
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

[data-theme="dark"] .floating-header {
  background: rgba(31, 41, 55, 0.95);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modern-home-btn {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: none;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modern-home-btn:hover {
  background: var(--accent-primary);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.3);
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-icon {
  width: 40px;
  height: 40px;
  background: var(--accent-gradient);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.brand-text h1 {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1;
}

.brand-text p {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}



.thinking-pulse {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse-dot 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

@keyframes pulse-dot {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.8; }
}

/* Main Content Area */
.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  padding-bottom: 140px; 
  padding-left: 16px;
  padding-right: 16px;
  overflow: visible; 
  min-height: 0; 
  height: 100vh; 
}

.export-dropdown {
  z-index: 1000;
}

/* Welcome State */
.welcome-state {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 40px;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.suggestions-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  flex-shrink: 0;
}

/* Chat State */
.chat-state {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  height: 100%; 
}

.chat-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  /* Add bottom padding to prevent content being hidden behind floating input */
  padding-bottom: 140px;
}

.messages-area {
  flex: 1 1;
  overflow: hidden;
  min-height: 0;
}

.messages-scroll {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  padding-bottom: 40px;
  background: var(--bg-gradient);
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}

.messages-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  height: 100%;
  background: var(--bg-gradient);
}

.messages-list {
  flex: 1 1;
  overflow: hidden;
  min-height: 0;
  height: 100%;
}

/* Advisor carousel: horizontal layout for multiple advisor responses */
.advisor-carousel {
  display: flex;
  align-items: stretch;
  gap: 12px;
  margin-bottom: 24px;
  min-height: 0;
  width: 100%;
}

.advisor-carousel .carousel-viewport {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.advisor-carousel .carousel-track {
  display: flex;
  height: 100%;
  transition: transform 0.25s ease-out;
}

/* Grid mode: wide layout, all advisor cards side by side */
.advisor-carousel.grid-mode .carousel-track {
  transform: none;
  gap: 16px;
}

.advisor-carousel.grid-mode .carousel-slide {
  flex: 1 1;
  min-width: 240px;
  max-width: 400px;
}

/* Carousel mode: narrow layout, one card at a time with arrows */
.advisor-carousel.carousel-mode {
  position: relative;
  padding: 0 40px;
}

.advisor-carousel.carousel-mode .carousel-track {
  width: 100%;
}

.advisor-carousel.carousel-mode .carousel-slide {
  width: 100%;
  flex-shrink: 0;
}

.advisor-carousel .carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--border-primary);
  background: var(--bg-secondary);
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  flex-shrink: 0;
  z-index: 2;
}

.advisor-carousel .carousel-arrow:hover:not(:disabled) {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
}

.advisor-carousel .carousel-arrow:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.advisor-carousel .carousel-prev {
  left: 0;
}

.advisor-carousel .carousel-next {
  right: 0;
}

.advisor-carousel .carousel-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  flex-shrink: 0;
}

.advisor-carousel .carousel-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background: var(--border-primary);
  cursor: pointer;
  transition: background 0.2s;
  padding: 0;
}

.advisor-carousel .carousel-dot.active,
.advisor-carousel .carousel-dot:hover {
  background: var(--accent-primary);
}

.single-response-wide {
  margin-bottom: 24px;
  width: 100%;
  max-width: 512px;
}


[data-theme="dark"] .messages-scroll,
[data-theme="dark"] .messages-container,
[data-theme="dark"] .main-content {
  background: var(--bg-gradient);
  will-change: auto;
  transform: translateZ(0);
}

/* Smooth scrolling with fixed background */
@media (prefers-reduced-motion: no-preference) {
  .messages-scroll {
    scroll-behavior: smooth;
  }
}

/* Scrollbar styling for dark mode */
[data-theme="dark"] .messages-scroll::-webkit-scrollbar {
  width: 8px;
}

[data-theme="dark"] .messages-scroll::-webkit-scrollbar-track {
  background: var(--bg-secondary);
  border-radius: 4px;
}

[data-theme="dark"] .messages-scroll::-webkit-scrollbar-thumb {
  background: var(--border-primary);
  border-radius: 4px;
}

[data-theme="dark"] .messages-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--text-tertiary);
}

/* Prevent background shift during scroll */
.messages-scroll * {
  background-attachment: fixed;
}

/* Ensure scroll anchor area */
.messages-end-anchor {
  height: 1px;
  background: transparent;
}


/* Message Components */
.orchestrator-message {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  align-items: flex-start;
}

.orchestrator-avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: var(--accent-gradient);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.orchestrator-content {
  flex: 1 1;
  background: var(--bg-secondary);
  border-radius: 16px;
  padding: 16px 20px;
  border: 1px solid var(--border-primary);
  max-width: 600px;
}

.orchestrator-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.orchestrator-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 14px;
}

.message-timestamp {
  font-size: 12px;
  color: var(--text-tertiary);
}

.orchestrator-text {
  color: var(--text-accent);
  line-height: 1.6;
  margin: 0;
}

/* System Notifications */
.system-notification {
  display: flex;
  justify-content: center;
  margin: 16px 0;
}

.system-content {
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  color: white;
  padding: 12px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
  text-align: center;
  max-width: 400px;
}

/* System Message Base Styles */
.system-message-container {
  display: flex;
  justify-content: center;
  margin: 16px 0;
}

.system-message {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  color: var(--text-secondary);
  text-align: center;
  max-width: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Document Upload Specific Styles */
.system-message.document-upload {
  background: #F0F9F4;
  border: 1px solid #10B981;
  border-left: 4px solid #10B981;
  color: #065F46;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.1);
  animation: slideInNotification 0.3s ease-out;
}

.system-message.document-upload svg {
  color: #10B981;
  flex-shrink: 0;
}

.system-message.document-upload p {
  margin: 0;
  line-height: 1.4;
}

[data-theme="dark"] .system-message.document-upload {
  background: rgba(16, 185, 129, 0.15);
  border-color: #10B981;
  color: #6EE7B7;
}

[data-theme="dark"] .system-message.document-upload svg {
  color: #34D399;
}

/* Animation for notification appearance */
@keyframes slideInNotification {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Thinking Indicators */
.orchestrator-thinking {
  display: flex;
  gap: 16px;
  align-items: center;
  opacity: 0.8;
  margin-bottom: 24px;
}

.orchestrator-thinking .thinking-bubble {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-gradient, var(--accent-primary));
  color: white;
  border: none;
  box-shadow: var(--shadow-sm);
}

.thinking-content {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--bg-secondary);
  border-radius: 16px;
  padding: 16px 20px;
  border: 1px solid var(--border-primary);
}

.thinking-label {
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}

.thinking-animation {
  display: flex;
  gap: 4px;
}

.thinking-animation .dot {
  width: 6px;
  height: 6px;
  background: var(--accent-primary);
  border-radius: 50%;
  animation: thinking-bounce 1.4s infinite ease-in-out both;
}

.thinking-animation .dot:nth-child(1) { animation-delay: -0.32s; }
.thinking-animation .dot:nth-child(2) { animation-delay: -0.16s; }
.thinking-animation .dot:nth-child(3) { animation-delay: 0s; }

@keyframes thinking-bounce {
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
}

/* Floating Input Area - FIXED VERSION */
.floating-input-area {
  position: fixed;
  bottom: 20px;
  left: 300px;
  right: 0;
  z-index: 50;
  background: transparent;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 860px;
  margin: 0 auto;
  transition: left 0.3s ease;
}

.floating-input-area.sidebar-collapsed {
  left: 70px;
}

/* Reply Banner in ChatPage - matches input width and fixes dark mode */
.floating-input-area .reply-banner {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 0 16px 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 768px;
  box-sizing: border-box;
}

[data-theme="dark"] .floating-input-area .reply-banner {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

/* Reply Info - Fix dark mode text color */
.floating-input-area .reply-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
  font-size: 14px;
}

.floating-input-area .reply-info strong {
  color: var(--accent-primary);
}

/* Cancel Reply Button */
.floating-input-area .cancel-reply {
  background: none;
  border: none;
  color: var(--text-tertiary);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.floating-input-area .cancel-reply:hover {
  background: var(--bg-secondary);
  color: var(--text-secondary);
}

/* MAIN LAYOUT WITH SIDEBAR - FIXED */
.chat-page-with-sidebar {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: var(--bg-gradient);
}

.main-chat-area {
  flex: 1 1;
  margin-left: 300px; /* Width of sidebar when expanded */
  display: flex;
  flex-direction: column;
  height: 100vh;
  transition: margin-left 0.3s ease;
  overflow: hidden;
}

/* FIXED: Chat area expansion when sidebar is collapsed */
.main-chat-area.sidebar-collapsed {
  margin-left: 70px; /* Width of sidebar when collapsed */
}

/* Session title display in header */
.session-title-display {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background: var(--bg-secondary, #f3f4f6);
  border-radius: 6px;
  margin-right: 8px;
}

.dark .session-title-display {
  background: var(--bg-secondary-dark, #374151);
}

.session-title-display span {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #111827);
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark .session-title-display span {
  color: var(--text-primary-dark, #f9fafb);
}

/* Optional header sign out button */
.header-signout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-secondary, #6b7280);
  transition: all 0.2s ease;
  margin-right: 8px;
}

.header-signout-btn:hover {
  background: var(--bg-secondary, #f3f4f6);
  color: #ef4444;
}

.dark .header-signout-btn:hover {
  background: var(--bg-secondary-dark, #374151);
}

.header-help-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  cursor: pointer;
  color: var(--text-secondary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.header-help-btn svg {
  width: 20px;
  height: 20px;
  display: block;
}

.header-help-btn:hover {
  background: var(--bg-secondary);
  border-color: #2663EB;
  color: #2663EB;
}

/* Loading session indicator */
.loading-session {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  color: var(--text-secondary);
  font-size: 14px;
  background: var(--bg-gradient);
}

[data-theme="dark"] .loading-session {
  color: var(--text-secondary-dark);
  background: var(--bg-gradient);
}

.dark .loading-session {
  color: var(--text-secondary-dark, #9ca3af);
}

.loading-session .loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--border-light, #e5e7eb);
  border-top: 2px solid var(--primary-color, #3b82f6);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.dark .loading-session .loading-spinner {
  border-color: var(--border-dark, #374151);
  border-top-color: var(--primary-color, #3b82f6);
}

/* Document Indicator Styles */
.document-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--feature-bg);  /* Use theme variable */
  border: 1px solid var(--accent-primary);  /* Use theme variable */
  border-radius: 20px;
  color: var(--accent-primary);  /* Use theme variable */
  font-size: 13px;
  font-weight: 600;
  cursor: default;
  transition: all 0.2s ease;
}

.document-indicator:hover {
  background: var(--accent-primary);
  color: white;
}

.doc-count {
  background: var(--accent-primary);
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 700;
  min-width: 16px;
  text-align: center;
  line-height: 1.2;
}

.document-indicator:hover .doc-count {
  background: white;
  color: var(--accent-primary);
}

/* Provider Dropdown Styles - FIXED */
.provider-dropdown {
  position: relative;
  display: inline-block;
}

.provider-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  min-width: 140px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.provider-button:hover:not(.loading) {
  background: var(--bg-secondary);
  border-color: var(--accent-primary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.provider-button.open {
  background: var(--bg-secondary);
  border-color: var(--accent-primary);
}

.provider-button.loading {
  opacity: 0.7;
  cursor: not-allowed;
}

.provider-button-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

.provider-icon {
  color: var(--accent-primary);
  flex-shrink: 0;
}

.provider-icon.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.provider-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.provider-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13px;
}

.provider-badge {
  font-size: 10px;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.provider-badge.gemini { color: #4285f4; }
.provider-badge.ollama { color: #10b981; }
.provider-badge.vllm   { color: #ef4444; }
.provider-badge.hybrid { color: #a855f7; }

[data-theme="dark"] .provider-badge.hybrid,
[data-theme="dark"] .provider-option-badge.hybrid {
  color: #ffffff;
}

.clarification-message-container {
  display: flex;
  justify-content: center;
  margin: 24px 0;
}

.clarification-message {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
  padding: 20px;
  border-radius: 16px;
  max-width: 600px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border-left: 4px solid var(--accent-primary);
  position: relative;
  overflow: hidden;
}

/* Add subtle accent background */
.clarification-message::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--accent-gradient);
  opacity: 0.03;
  pointer-events: none;
}

[data-theme="dark"] .clarification-message {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

[data-theme="dark"] .clarification-message::before {
  opacity: 0.05;
}

.clarification-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 14px;
  color: var(--accent-primary);
  position: relative;
  z-index: 1;
}

.clarification-message p {
  margin: 0 0 16px 0;
  line-height: 1.6;
  font-size: 15px;
  color: var(--text-secondary);
  position: relative;
  z-index: 1;
}

.clarification-suggestions {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border-primary);
  position: relative;
  z-index: 1;
}

.suggestions-label {
  font-size: 13px;
  margin-bottom: 12px;
  color: var(--text-secondary);
  font-weight: 500;
}

.suggestions-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.suggestion-button {
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
  padding: 12px 16px;
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.suggestion-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--accent-primary);
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.suggestion-button:hover {
  border-color: var(--accent-primary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.suggestion-button:hover::before {
  opacity: 0.05;
}

.suggestion-button:hover {
  color: var(--accent-primary);
}

[data-theme="dark"] .suggestion-button:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

[data-theme="dark"] .suggestion-button:hover::before {
  opacity: 0.1;
}

.suggestion-button:active {
  transform: translateY(0);
}

.dropdown-arrow {
  color: var(--text-secondary);
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.provider-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 220px;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

[data-theme="dark"] .provider-dropdown-menu {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
}

.provider-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: none;
  background: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
}

.provider-option:hover:not(.selected) {
  background: var(--bg-secondary);
}

.provider-option.selected {
  background: var(--feature-bg);
  cursor: default;
}

.provider-option-icon {
  color: var(--accent-primary);
  flex-shrink: 0;
}

.provider-option-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.provider-option-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.provider-option-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13px;
}

.provider-option-badge {
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.provider-option-badge.gemini {
  background: rgba(66, 133, 244, 0.15);
  color: #4285f4;
}

.provider-option-badge.ollama {
  background: rgba(16, 185, 129, 0.15);
  color: #10b981;
}

.provider-option-badge.vllm {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.provider-option-badge.hybrid {
  background: rgba(168, 85, 247, 0.15);
  color: #a855f7;
}

.provider-option-configure {
  margin-left: 8px;
  background: transparent;
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: 6px;
  padding: 4px 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: var(--text-secondary, #6b7280);
}

.provider-option-configure:hover {
  background: var(--accent-primary);
  color: #fff;
  border-color: var(--accent-primary);
}

[data-theme="dark"] .provider-option-configure {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.25);
}

.provider-option-description {
  font-size: 11px;
  color: var(--text-tertiary);
}

.provider-option-checkmark {
  color: var(--accent-primary);
  font-weight: bold;
  font-size: 12px;
}

.mobile-menu-button {
  display: none;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: none;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  align-items: center;
  justify-content: center;
}

.mobile-menu-button:hover {
  background: var(--accent-primary);
  color: white;
}

/* Responsive Design for Chat Page */
@media (max-width: 768px) {
  .floating-header {
    padding: 12px 16px;
    flex-wrap: nowrap; 
    gap: 8px;
  }
  
  .header-left {
    gap: 12px;
    flex: 0 1; /* Don't let it grow */
    min-width: 0;
  }
  
  /* Hide brand elements on mobile to reduce clutter */
  .header-left .modern-home-btn,
  .header-left .header-brand {
    display: none;
  }
  
  .header-right {
    gap: 8px;
    flex: 1 1; /* Let header-right take available space */
    justify-content: flex-end; /* Align items to the right */
    flex-shrink: 0;
  }
  
  /* Ensure mobile menu button is visible */
  .mobile-menu-button {
    display: flex;
  }
  
  .main-content {
    padding: 24px 12px 120px 12px; /* Adjusted for mobile */
  }
  
  .welcome-state {
    min-height: 50vh;
  }
  
  .messages-scroll {
    padding: 16px;
    padding-bottom: 30px;
  }
  
  .floating-input-area,
  .floating-input-area.sidebar-collapsed {
    bottom: 10px;
    left: 0;
  }
  
  .floating-input-area .reply-banner {
    margin: 0 12px 12px 12px;
  }
  
  .orchestrator-content {
    max-width: none;
  }
  
  .system-content {
    max-width: 90%;
    padding: 10px 16px;
    font-size: 13px;
  }


  .main-chat-area {
    margin-left: 0;
  }

  .main-chat-area.sidebar-collapsed {
    margin-left: 0;
  }

  .clarification-message {
    margin: 0 16px;
    max-width: none;
    padding: 16px;
  }
  
  .clarification-header {
    font-size: 13px;
  }
  
  .clarification-message p {
    font-size: 14px;
  }
  
  .suggestion-button {
    padding: 10px 14px;
    font-size: 12px;
  }

  .brand-text h1 {
    font-size: 16px;
  }
  
  .brand-text p {
    font-size: 11px;
  }

  .session-title-display{
    display: none;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/ChatPage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EAEjB,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;;AAIA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,WAAW,mBAAmB,EAAE,UAAU,EAAE;EAC5C,MAAM,qBAAqB,EAAE,YAAY,EAAE;AAC7C;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,6EAA6E;EAC7E,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oCAAoC;AACtC;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uCAAuC;EACvC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;;AAGA;;;EAGE,8BAA8B;EAC9B,iBAAiB;EAEjB,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,oCAAoC;AACpC;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,uBAAuB;AACzB;;;AAGA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mFAAmF;EACnF,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAAyD;EACzD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA,wCAAwC,uBAAuB,EAAE;AACjE,wCAAwC,uBAAuB,EAAE;AACjE,wCAAwC,mBAAmB,EAAE;;AAE7D;EACE,gBAAgB,mBAAmB,EAAE;EACrC,MAAM,mBAAmB,EAAE;AAC7B;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA,uEAAuE;AACvE;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,kBAAkB,EAAE,mCAAmC;EACvD,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,mDAAmD;EACnD,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B,GAAG,uBAAuB;EACvD,uCAAuC,GAAG,uBAAuB;EACjE,mBAAmB;EACnB,4BAA4B,GAAG,uBAAuB;EACtD,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;;AAEzC;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,SAAO,EAAE,sBAAsB;IAC/B,YAAY;EACd;;EAEA,oDAAoD;EACpD;;IAEE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,SAAO,EAAE,0CAA0C;IACnD,yBAAyB,EAAE,6BAA6B;IACxD,cAAc;EAChB;;EAEA,yCAAyC;EACzC;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B,EAAE,wBAAwB;EACzD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;;IAEE,YAAY;IACZ,OAAO;EACT;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;;EAGA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;AAEF","sourcesContent":["/* Modern Chat Page Layout */\n.modern-chat-page {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n[data-theme=\"dark\"] .modern-chat-page {\n  background: var(--bg-gradient);\n  will-change: auto;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n/* Floating Header */\n.floating-header {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-bottom: 1px solid var(--border-primary);\n  padding: 12px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  flex-shrink: 0;\n}\n\n[data-theme=\"dark\"] .floating-header {\n  background: rgba(31, 41, 55, 0.95);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.modern-home-btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  border: none;\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.modern-home-btn:hover {\n  background: var(--accent-primary);\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.3);\n}\n\n.header-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.brand-icon {\n  width: 40px;\n  height: 40px;\n  background: var(--accent-gradient);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.brand-text h1 {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1;\n}\n\n.brand-text p {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.header-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n\n\n.thinking-pulse {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  animation: pulse-dot 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n@keyframes pulse-dot {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.2); opacity: 0.8; }\n}\n\n/* Main Content Area */\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-top: 24px;\n  padding-bottom: 140px; \n  padding-left: 16px;\n  padding-right: 16px;\n  overflow: visible; \n  min-height: 0; \n  height: 100vh; \n}\n\n.export-dropdown {\n  z-index: 1000;\n}\n\n/* Welcome State */\n.welcome-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding-top: 40px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n}\n\n.suggestions-container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  flex-shrink: 0;\n}\n\n/* Chat State */\n.chat-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n  height: 100%; \n}\n\n.chat-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n  /* Add bottom padding to prevent content being hidden behind floating input */\n  padding-bottom: 140px;\n}\n\n.messages-area {\n  flex: 1;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.messages-scroll {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 20px;\n  padding-bottom: 40px;\n  background: var(--bg-gradient);\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n}\n\n.messages-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n  height: 100%;\n  background: var(--bg-gradient);\n}\n\n.messages-list {\n  flex: 1;\n  overflow: hidden;\n  min-height: 0;\n  height: 100%;\n}\n\n/* Advisor carousel: horizontal layout for multiple advisor responses */\n.advisor-carousel {\n  display: flex;\n  align-items: stretch;\n  gap: 12px;\n  margin-bottom: 24px;\n  min-height: 0;\n  width: 100%;\n}\n\n.advisor-carousel .carousel-viewport {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.advisor-carousel .carousel-track {\n  display: flex;\n  height: 100%;\n  transition: transform 0.25s ease-out;\n}\n\n/* Grid mode: wide layout, all advisor cards side by side */\n.advisor-carousel.grid-mode .carousel-track {\n  transform: none;\n  gap: 16px;\n}\n\n.advisor-carousel.grid-mode .carousel-slide {\n  flex: 1 1 0;\n  min-width: 240px;\n  max-width: 400px;\n}\n\n/* Carousel mode: narrow layout, one card at a time with arrows */\n.advisor-carousel.carousel-mode {\n  position: relative;\n  padding: 0 40px;\n}\n\n.advisor-carousel.carousel-mode .carousel-track {\n  width: 100%;\n}\n\n.advisor-carousel.carousel-mode .carousel-slide {\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.advisor-carousel .carousel-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid var(--border-primary);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n  flex-shrink: 0;\n  z-index: 2;\n}\n\n.advisor-carousel .carousel-arrow:hover:not(:disabled) {\n  background: var(--accent-primary);\n  color: white;\n  border-color: var(--accent-primary);\n}\n\n.advisor-carousel .carousel-arrow:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.advisor-carousel .carousel-prev {\n  left: 0;\n}\n\n.advisor-carousel .carousel-next {\n  right: 0;\n}\n\n.advisor-carousel .carousel-dots {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 12px;\n  flex-shrink: 0;\n}\n\n.advisor-carousel .carousel-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: none;\n  background: var(--border-primary);\n  cursor: pointer;\n  transition: background 0.2s;\n  padding: 0;\n}\n\n.advisor-carousel .carousel-dot.active,\n.advisor-carousel .carousel-dot:hover {\n  background: var(--accent-primary);\n}\n\n.single-response-wide {\n  margin-bottom: 24px;\n  width: 100%;\n  max-width: 512px;\n}\n\n\n[data-theme=\"dark\"] .messages-scroll,\n[data-theme=\"dark\"] .messages-container,\n[data-theme=\"dark\"] .main-content {\n  background: var(--bg-gradient);\n  will-change: auto;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n/* Smooth scrolling with fixed background */\n@media (prefers-reduced-motion: no-preference) {\n  .messages-scroll {\n    scroll-behavior: smooth;\n  }\n}\n\n/* Scrollbar styling for dark mode */\n[data-theme=\"dark\"] .messages-scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n[data-theme=\"dark\"] .messages-scroll::-webkit-scrollbar-track {\n  background: var(--bg-secondary);\n  border-radius: 4px;\n}\n\n[data-theme=\"dark\"] .messages-scroll::-webkit-scrollbar-thumb {\n  background: var(--border-primary);\n  border-radius: 4px;\n}\n\n[data-theme=\"dark\"] .messages-scroll::-webkit-scrollbar-thumb:hover {\n  background: var(--text-tertiary);\n}\n\n/* Prevent background shift during scroll */\n.messages-scroll * {\n  background-attachment: fixed;\n}\n\n/* Ensure scroll anchor area */\n.messages-end-anchor {\n  height: 1px;\n  background: transparent;\n}\n\n\n/* Message Components */\n.orchestrator-message {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  align-items: flex-start;\n}\n\n.orchestrator-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 20px;\n  background: var(--accent-gradient);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n}\n\n.orchestrator-content {\n  flex: 1;\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  padding: 16px 20px;\n  border: 1px solid var(--border-primary);\n  max-width: 600px;\n}\n\n.orchestrator-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.orchestrator-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 14px;\n}\n\n.message-timestamp {\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n\n.orchestrator-text {\n  color: var(--text-accent);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* System Notifications */\n.system-notification {\n  display: flex;\n  justify-content: center;\n  margin: 16px 0;\n}\n\n.system-content {\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\n  color: white;\n  padding: 12px 20px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\n  text-align: center;\n  max-width: 400px;\n}\n\n/* System Message Base Styles */\n.system-message-container {\n  display: flex;\n  justify-content: center;\n  margin: 16px 0;\n}\n\n.system-message {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  color: var(--text-secondary);\n  text-align: center;\n  max-width: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* Document Upload Specific Styles */\n.system-message.document-upload {\n  background: #F0F9F4;\n  border: 1px solid #10B981;\n  border-left: 4px solid #10B981;\n  color: #065F46;\n  font-weight: 500;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.1);\n  animation: slideInNotification 0.3s ease-out;\n}\n\n.system-message.document-upload svg {\n  color: #10B981;\n  flex-shrink: 0;\n}\n\n.system-message.document-upload p {\n  margin: 0;\n  line-height: 1.4;\n}\n\n[data-theme=\"dark\"] .system-message.document-upload {\n  background: rgba(16, 185, 129, 0.15);\n  border-color: #10B981;\n  color: #6EE7B7;\n}\n\n[data-theme=\"dark\"] .system-message.document-upload svg {\n  color: #34D399;\n}\n\n/* Animation for notification appearance */\n@keyframes slideInNotification {\n  from {\n    opacity: 0;\n    transform: translateY(-8px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Thinking Indicators */\n.orchestrator-thinking {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  opacity: 0.8;\n  margin-bottom: 24px;\n}\n\n.orchestrator-thinking .thinking-bubble {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  min-height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--accent-gradient, var(--accent-primary));\n  color: white;\n  border: none;\n  box-shadow: var(--shadow-sm);\n}\n\n.thinking-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  padding: 16px 20px;\n  border: 1px solid var(--border-primary);\n}\n\n.thinking-label {\n  font-size: 14px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.thinking-animation {\n  display: flex;\n  gap: 4px;\n}\n\n.thinking-animation .dot {\n  width: 6px;\n  height: 6px;\n  background: var(--accent-primary);\n  border-radius: 50%;\n  animation: thinking-bounce 1.4s infinite ease-in-out both;\n}\n\n.thinking-animation .dot:nth-child(1) { animation-delay: -0.32s; }\n.thinking-animation .dot:nth-child(2) { animation-delay: -0.16s; }\n.thinking-animation .dot:nth-child(3) { animation-delay: 0s; }\n\n@keyframes thinking-bounce {\n  0%, 80%, 100% { transform: scale(0); }\n  40% { transform: scale(1); }\n}\n\n/* Floating Input Area - FIXED VERSION */\n.floating-input-area {\n  position: fixed;\n  bottom: 20px;\n  left: 300px;\n  right: 0;\n  z-index: 50;\n  background: transparent;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 860px;\n  margin: 0 auto;\n  transition: left 0.3s ease;\n}\n\n.floating-input-area.sidebar-collapsed {\n  left: 70px;\n}\n\n/* Reply Banner in ChatPage - matches input width and fixes dark mode */\n.floating-input-area .reply-banner {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin: 0 16px 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  width: 100%;\n  max-width: 768px;\n  box-sizing: border-box;\n}\n\n[data-theme=\"dark\"] .floating-input-area .reply-banner {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n}\n\n/* Reply Info - Fix dark mode text color */\n.floating-input-area .reply-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.floating-input-area .reply-info strong {\n  color: var(--accent-primary);\n}\n\n/* Cancel Reply Button */\n.floating-input-area .cancel-reply {\n  background: none;\n  border: none;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.floating-input-area .cancel-reply:hover {\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n}\n\n/* MAIN LAYOUT WITH SIDEBAR - FIXED */\n.chat-page-with-sidebar {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n  background: var(--bg-gradient);\n}\n\n.main-chat-area {\n  flex: 1;\n  margin-left: 300px; /* Width of sidebar when expanded */\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  transition: margin-left 0.3s ease;\n  overflow: hidden;\n}\n\n/* FIXED: Chat area expansion when sidebar is collapsed */\n.main-chat-area.sidebar-collapsed {\n  margin-left: 70px; /* Width of sidebar when collapsed */\n}\n\n/* Session title display in header */\n.session-title-display {\n  display: flex;\n  align-items: center;\n  padding: 6px 12px;\n  background: var(--bg-secondary, #f3f4f6);\n  border-radius: 6px;\n  margin-right: 8px;\n}\n\n.dark .session-title-display {\n  background: var(--bg-secondary-dark, #374151);\n}\n\n.session-title-display span {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary, #111827);\n  max-width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dark .session-title-display span {\n  color: var(--text-primary-dark, #f9fafb);\n}\n\n/* Optional header sign out button */\n.header-signout-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border: none;\n  background: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--text-secondary, #6b7280);\n  transition: all 0.2s ease;\n  margin-right: 8px;\n}\n\n.header-signout-btn:hover {\n  background: var(--bg-secondary, #f3f4f6);\n  color: #ef4444;\n}\n\n.dark .header-signout-btn:hover {\n  background: var(--bg-secondary-dark, #374151);\n}\n\n.header-help-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.header-help-btn svg {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n\n.header-help-btn:hover {\n  background: var(--bg-secondary);\n  border-color: #2663EB;\n  color: #2663EB;\n}\n\n/* Loading session indicator */\n.loading-session {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px;\n  color: var(--text-secondary);\n  font-size: 14px;\n  background: var(--bg-gradient);\n}\n\n[data-theme=\"dark\"] .loading-session {\n  color: var(--text-secondary-dark);\n  background: var(--bg-gradient);\n}\n\n.dark .loading-session {\n  color: var(--text-secondary-dark, #9ca3af);\n}\n\n.loading-session .loading-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--border-light, #e5e7eb);\n  border-top: 2px solid var(--primary-color, #3b82f6);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.dark .loading-session .loading-spinner {\n  border-color: var(--border-dark, #374151);\n  border-top-color: var(--primary-color, #3b82f6);\n}\n\n/* Document Indicator Styles */\n.document-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: var(--feature-bg);  /* Use theme variable */\n  border: 1px solid var(--accent-primary);  /* Use theme variable */\n  border-radius: 20px;\n  color: var(--accent-primary);  /* Use theme variable */\n  font-size: 13px;\n  font-weight: 600;\n  cursor: default;\n  transition: all 0.2s ease;\n}\n\n.document-indicator:hover {\n  background: var(--accent-primary);\n  color: white;\n}\n\n.doc-count {\n  background: var(--accent-primary);\n  color: white;\n  border-radius: 10px;\n  padding: 2px 6px;\n  font-size: 11px;\n  font-weight: 700;\n  min-width: 16px;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.document-indicator:hover .doc-count {\n  background: white;\n  color: var(--accent-primary);\n}\n\n/* Provider Dropdown Styles - FIXED */\n.provider-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.provider-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  min-width: 140px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.provider-button:hover:not(.loading) {\n  background: var(--bg-secondary);\n  border-color: var(--accent-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.provider-button.open {\n  background: var(--bg-secondary);\n  border-color: var(--accent-primary);\n}\n\n.provider-button.loading {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.provider-button-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.provider-icon {\n  color: var(--accent-primary);\n  flex-shrink: 0;\n}\n\n.provider-icon.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.provider-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.provider-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 13px;\n}\n\n.provider-badge {\n  font-size: 10px;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.provider-badge.gemini { color: #4285f4; }\n.provider-badge.ollama { color: #10b981; }\n.provider-badge.vllm   { color: #ef4444; }\n.provider-badge.hybrid { color: #a855f7; }\n\n[data-theme=\"dark\"] .provider-badge.hybrid,\n[data-theme=\"dark\"] .provider-option-badge.hybrid {\n  color: #ffffff;\n}\n\n.clarification-message-container {\n  display: flex;\n  justify-content: center;\n  margin: 24px 0;\n}\n\n.clarification-message {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  color: var(--text-primary);\n  padding: 20px;\n  border-radius: 16px;\n  max-width: 600px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  border-left: 4px solid var(--accent-primary);\n  position: relative;\n  overflow: hidden;\n}\n\n/* Add subtle accent background */\n.clarification-message::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--accent-gradient);\n  opacity: 0.03;\n  pointer-events: none;\n}\n\n[data-theme=\"dark\"] .clarification-message {\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n[data-theme=\"dark\"] .clarification-message::before {\n  opacity: 0.05;\n}\n\n.clarification-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--accent-primary);\n  position: relative;\n  z-index: 1;\n}\n\n.clarification-message p {\n  margin: 0 0 16px 0;\n  line-height: 1.6;\n  font-size: 15px;\n  color: var(--text-secondary);\n  position: relative;\n  z-index: 1;\n}\n\n.clarification-suggestions {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-primary);\n  position: relative;\n  z-index: 1;\n}\n\n.suggestions-label {\n  font-size: 13px;\n  margin-bottom: 12px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.suggestions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.suggestion-button {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  color: var(--text-primary);\n  padding: 12px 16px;\n  border-radius: 12px;\n  cursor: pointer;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.suggestion-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--accent-primary);\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n}\n\n.suggestion-button:hover {\n  border-color: var(--accent-primary);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.suggestion-button:hover::before {\n  opacity: 0.05;\n}\n\n.suggestion-button:hover {\n  color: var(--accent-primary);\n}\n\n[data-theme=\"dark\"] .suggestion-button:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n[data-theme=\"dark\"] .suggestion-button:hover::before {\n  opacity: 0.1;\n}\n\n.suggestion-button:active {\n  transform: translateY(0);\n}\n\n.dropdown-arrow {\n  color: var(--text-secondary);\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.dropdown-arrow.rotated {\n  transform: rotate(180deg);\n}\n\n.provider-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 220px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  overflow: hidden;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n[data-theme=\"dark\"] .provider-dropdown-menu {\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);\n}\n\n.provider-option {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  text-align: left;\n}\n\n.provider-option:hover:not(.selected) {\n  background: var(--bg-secondary);\n}\n\n.provider-option.selected {\n  background: var(--feature-bg);\n  cursor: default;\n}\n\n.provider-option-icon {\n  color: var(--accent-primary);\n  flex-shrink: 0;\n}\n\n.provider-option-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.provider-option-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.provider-option-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 13px;\n}\n\n.provider-option-badge {\n  font-size: 9px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.provider-option-badge.gemini {\n  background: rgba(66, 133, 244, 0.15);\n  color: #4285f4;\n}\n\n.provider-option-badge.ollama {\n  background: rgba(16, 185, 129, 0.15);\n  color: #10b981;\n}\n\n.provider-option-badge.vllm {\n  background: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n}\n\n.provider-option-badge.hybrid {\n  background: rgba(168, 85, 247, 0.15);\n  color: #a855f7;\n}\n\n.provider-option-configure {\n  margin-left: 8px;\n  background: transparent;\n  border: 1px solid var(--border-color, #d1d5db);\n  border-radius: 6px;\n  padding: 4px 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  color: var(--text-secondary, #6b7280);\n}\n\n.provider-option-configure:hover {\n  background: var(--accent-primary);\n  color: #fff;\n  border-color: var(--accent-primary);\n}\n\n[data-theme=\"dark\"] .provider-option-configure {\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.provider-option-description {\n  font-size: 11px;\n  color: var(--text-tertiary);\n}\n\n.provider-option-checkmark {\n  color: var(--accent-primary);\n  font-weight: bold;\n  font-size: 12px;\n}\n\n.mobile-menu-button {\n  display: none;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  border: none;\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  align-items: center;\n  justify-content: center;\n}\n\n.mobile-menu-button:hover {\n  background: var(--accent-primary);\n  color: white;\n}\n\n/* Responsive Design for Chat Page */\n@media (max-width: 768px) {\n  .floating-header {\n    padding: 12px 16px;\n    flex-wrap: nowrap; \n    gap: 8px;\n  }\n  \n  .header-left {\n    gap: 12px;\n    flex: 0; /* Don't let it grow */\n    min-width: 0;\n  }\n  \n  /* Hide brand elements on mobile to reduce clutter */\n  .header-left .modern-home-btn,\n  .header-left .header-brand {\n    display: none;\n  }\n  \n  .header-right {\n    gap: 8px;\n    flex: 1; /* Let header-right take available space */\n    justify-content: flex-end; /* Align items to the right */\n    flex-shrink: 0;\n  }\n  \n  /* Ensure mobile menu button is visible */\n  .mobile-menu-button {\n    display: flex;\n  }\n  \n  .main-content {\n    padding: 24px 12px 120px 12px; /* Adjusted for mobile */\n  }\n  \n  .welcome-state {\n    min-height: 50vh;\n  }\n  \n  .messages-scroll {\n    padding: 16px;\n    padding-bottom: 30px;\n  }\n  \n  .floating-input-area,\n  .floating-input-area.sidebar-collapsed {\n    bottom: 10px;\n    left: 0;\n  }\n  \n  .floating-input-area .reply-banner {\n    margin: 0 12px 12px 12px;\n  }\n  \n  .orchestrator-content {\n    max-width: none;\n  }\n  \n  .system-content {\n    max-width: 90%;\n    padding: 10px 16px;\n    font-size: 13px;\n  }\n\n\n  .main-chat-area {\n    margin-left: 0;\n  }\n\n  .main-chat-area.sidebar-collapsed {\n    margin-left: 0;\n  }\n\n  .clarification-message {\n    margin: 0 16px;\n    max-width: none;\n    padding: 16px;\n  }\n  \n  .clarification-header {\n    font-size: 13px;\n  }\n  \n  .clarification-message p {\n    font-size: 14px;\n  }\n  \n  .suggestion-button {\n    padding: 10px 14px;\n    font-size: 12px;\n  }\n\n  .brand-text h1 {\n    font-size: 16px;\n  }\n  \n  .brand-text p {\n    font-size: 11px;\n  }\n\n  .session-title-display{\n    display: none;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
